import React from 'react';
import { Card, Button, Tooltip, Typography } from 'antd';
import {
    FireOutlined,
    ClockCircleOutlined,
    TrophyOutlined,
    FileExcelOutlined,
    AppstoreOutlined
} from '@ant-design/icons';

const { Text } = Typography;

const QuickActionsToolbar = ({
    activeStatusFilter = 'all',
    hasActiveFilters = false,
    onQuickFilter,
    onExportCSV,
    exportDisabled = false,
    showQuickFilters = true,
    showExport = true,
    customFilters = null // Optional: custom filter buttons
}) => {
    return (
        <>
            <Card 
                className="quick-actions-toolbar"
                style={{ 
                    marginBottom: 16,
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                    border: '1px solid #e8f4f8'
                }}
                bodyStyle={{ padding: '12px 16px' }}
            >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                    {/* Left Side - Quick Filters */}
                    {showQuickFilters && (
                        <div className="d-flex flex-wrap gap-2 align-items-center">
                            <Text 
                                strong 
                                className="quick-filters-label"
                                style={{ 
                                    fontSize: '13px', 
                                    color: '#595959', 
                                    marginRight: '4px'
                                }}
                            >
                                Quick Filters:
                            </Text>
                            {customFilters ? (
                                customFilters
                            ) : (
                                <>
                                    <Tooltip title="All Auctions">
                                        <Button
                                            size="small"
                                            type={activeStatusFilter === 'all' && !hasActiveFilters ? 'primary' : 'default'}
                                            onClick={() => onQuickFilter && onQuickFilter('all')}
                                            icon={<AppstoreOutlined />}
                                            className="all-filter-btn"
                                            style={{ 
                                                borderRadius: '6px',
                                                color: (activeStatusFilter === 'all' && !hasActiveFilters) ? '#ffffff' : undefined
                                            }}
                                        >
                                            <span className="d-none d-md-inline">All</span>
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Active Auctions">
                                        <Button
                                            size="small"
                                            type={activeStatusFilter === 'active' ? 'primary' : 'default'}
                                            onClick={() => onQuickFilter && onQuickFilter('active')}
                                            icon={<FireOutlined />}
                                            style={{ borderRadius: '6px' }}
                                        >
                                            <span className="d-none d-md-inline">Active</span>
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Scheduled Auctions">
                                        <Button
                                            size="small"
                                            type={activeStatusFilter === 'scheduled' ? 'primary' : 'default'}
                                            onClick={() => onQuickFilter && onQuickFilter('scheduled')}
                                            icon={<ClockCircleOutlined />}
                                            style={{ borderRadius: '6px' }}
                                        >
                                            <span className="d-none d-md-inline">Scheduled</span>
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Completed Auctions">
                                        <Button
                                            size="small"
                                            type={activeStatusFilter === 'completed' ? 'primary' : 'default'}
                                            onClick={() => onQuickFilter && onQuickFilter('completed')}
                                            icon={<TrophyOutlined />}
                                            style={{ borderRadius: '6px' }}
                                        >
                                            <span className="d-none d-md-inline">Completed</span>
                                        </Button>
                                    </Tooltip>
                                </>
                            )}
                        </div>
                    )}

                    {/* Right Side - Actions */}
                    {showExport && (
                        <div className="d-flex flex-wrap gap-2 align-items-center">
                            <Tooltip title="Export filtered data to CSV">
                                <Button
                                    size="small"
                                    icon={<FileExcelOutlined />}
                                    onClick={onExportCSV}
                                    disabled={exportDisabled}
                                    style={{ borderRadius: '6px' }}
                                >
                                    <span className="d-none d-md-inline">Export CSV</span>
                                </Button>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </Card>
            <style>{`
                /* Mobile: Show icons only (but keep label visible) */
                @media (max-width: 767.98px) {
                    .quick-actions-toolbar .ant-btn {
                        min-width: 36px;
                        padding: 4px 8px;
                    }
                    
                    .quick-actions-toolbar .ant-btn-icon-only {
                        padding: 4px 8px;
                    }
                }
                
                /* Tablet and Desktop: Show full text with icons */
                @media (min-width: 768px) {
                    .quick-actions-toolbar .ant-btn {
                        padding: 4px 12px;
                    }
                }
                
                /* Ensure "All" button text is white when primary */
                .quick-actions-toolbar .all-filter-btn.ant-btn-primary {
                    color: #ffffff !important;
                }
                
                .quick-actions-toolbar .all-filter-btn.ant-btn-primary:hover {
                    color: #ffffff !important;
                }
            `}</style>
        </>
    );
};

export default QuickActionsToolbar;

